import React, { useEffect } from "react";
import Routes from "./Routes";
import { BrowserRouter as Router } from "react-router-dom";
import ScrollToTop from "components/Misc/ScrollToTop";

function App() {
  useEffect(() => {
    // Fetch the PHP script to log the visitor's IP
    fetch("/log-visitor.php")
      .then((response) => {
        console.log("Visitor logged successfully");
      })
      .catch((error) => {
        console.error("Error logging visitor: ", error);
      });
  }, []);
  return (
    <Router>
      <ScrollToTop />
      <Routes />
    </Router>
  );
}

export default App;
